import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import { Provider } from 'react-redux';
import store from './store';
import { graphqlUri } from './api/axios';



const client = new ApolloClient({
  uri: graphqlUri,
  cache: new InMemoryCache({
    addTypename: false,
    resultCaching: false,
  }),
});



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <ApolloProvider client={client}>
      <Provider store = {store}>
          <App/>          
      </Provider>
    </ApolloProvider>
);


